<template>
  <!-- 外层宽度、margin 与上方 core_options 统一 -->
  <div class="core_one_wrap" v-if="relationProductList.length">
    <div class="relation-wrap">
      <div class="product-grid">
        <div
            class="product-card"
            v-for="item in relationProductList"
            :key="item.productNo"
            @click="goDetail(item.productNo)"
        >
          <div class="card-img">
            <img :src="item.mainImage" alt="" />
          </div>
          <div class="card-name">{{ item.productName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollReveal from 'scrollreveal'
import { getHotProductListByNos } from '../../api/system'

export default {
  data() {
    return {
      relationProductList: []
    }
  },
  props: {
    productNo: {
      type: String,
      required: true
    },
    core: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    productNo: {
      immediate: true,
      handler() {
        this.loadProductData()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      ScrollReveal().reveal('.relation-wrap', {
        distance: '10px',
        duration: 800,
        reset: false,
        viewFactor: 0.6
      })
    })
  },
  methods: {
    async loadProductData() {
      this.relationProductList = []
      try {
        const res = await getHotProductListByNos(this.productNo)
        if (res.data.code === 200) {
          const allProduct = res.data.data.filter(item => !!item)
          this.relationProductList = allProduct
        }
      } catch (e) {
        console.error('加载产品失败', e)
      }
    },
    goDetail(productNo) {
      this.$router.push('/production/detail?productNo=' + productNo)
    }
  }
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  /* 和上方 core_options 宽度一致：PC70%，移动端90% */
  width: 70%;
  margin: 0 auto;
  padding: 40px 0;

  @media screen and (max-width: 768px) {
    width: 90%;
    padding: 20px 0;
  }

  .relation-wrap {
    width: 100%;
    .product-grid {
      // PC端一行3个
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 22px;
      width: 100%;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
      }
      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 15px;
      }
    }

    .product-card {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      width: 100%;
      border: 1px solid #cecccc;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      overflow: hidden;
      transition: all 0.3s ease;

      @media (max-width: 768px) {
        border-radius: 0;
      }

      .card-img {
        width: 100%;
        height: 450px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background-color: #fff;

        @media (max-width: 768px) {
          height: 350px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          transition: transform 0.3s ease;
        }
      }

      .card-name {
        width: 100%;
        height: 80px;
        background: #3a3d51;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        font-size: 18px;
        text-align: center;
        transition: background 0.3s ease;
        box-sizing: border-box;
        font-weight: bold;
        font-family: 'Roboto', sans-serif;

        @media (max-width: 768px) {
          height: 70px;
          font-size: 16px;
        }
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);

        .card-img img {
          transform: scale(1.05);
        }

        .card-name {
          background: #880f53;
        }
      }
    }
  }
}
</style>